import React, { useContext } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import "./accountRefundPolicy.css";
import translations from "../../../translations/translations";

const COMPANY_NAME = "ReservaSinFila";
const CONTACT_EMAIL = "soporte@reservasinfila.com";
const LAST_UPDATED = "October 14, 2025";

const renderParagraphs = (section) =>
	Object.keys(section || {})
		.filter((k) => k.startsWith("p"))
		.map((key) => (
			<p key={key}>
				{section[key]?.replace("{{COMPANY_NAME}}", COMPANY_NAME)}
			</p>
		));

const AccountRefundPolicy = () => {
	const { language } = useContext(CombinedContext);
	const t = translations[language].refund;

	return (
		<div className="refund-page">
			<div className="refund-container">
				{/* HEADER */}
				<header className="refund-header">
					<h1>{t.title}</h1>
					<p className="refund-updated">
						{t.lastUpdated}: {LAST_UPDATED}
					</p>
				</header>

				{/* INTRO */}
				<section className="refund-section">
					{renderParagraphs(t.intro)}
				</section>

				{/* 1) PLATFORM FEES */}
				<section className="refund-section">
					<h2>{t.platformFees.heading}</h2>
					{renderParagraphs(t.platformFees)}
				</section>

				{/* 2) ELIGIBILITY */}
				<section className="refund-section">
					<h2>{t.eligibility.heading}</h2>
					<ul>
						{t.eligibility.list.map((item, i) => (
							<li key={i}>{item}</li>
						))}
					</ul>
				</section>

				{/* 3) MID-MONTH */}
				<section className="refund-section">
					<h2>{t.midMonth.heading}</h2>
					{renderParagraphs(t.midMonth)}
				</section>

				{/* 4) PROCESS */}
				<section className="refund-section">
					<h2>{t.process.heading}</h2>
					{renderParagraphs(t.process)}
				</section>

				{/* 5) NON-REFUNDABLE */}
				<section className="refund-section">
					<h2>{t.nonRefundable.heading}</h2>
					<ul>
						{t.nonRefundable.list.map((item, i) => (
							<li key={i}>{item}</li>
						))}
					</ul>
				</section>

				{/* 6) CHANGES */}
				<section className="refund-section">
					<h2>{t.changes.heading}</h2>
					<p>{t.changes.text}</p>
				</section>

				{/* 7) CONTACT */}
				<section className="refund-section">
					<h2>{t.contact.heading}</h2>
					<p>{t.contact.text.replace("{{CONTACT_EMAIL}}", CONTACT_EMAIL)}</p>
				</section>
			</div>
		</div>
	);
};

export default AccountRefundPolicy;
